import React from "react";
import Grid from "@material-ui/core/Grid";
import { sto } from "../../../../Context/InshData";
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { styleFooterNotesAr } from "../../ShareFunctionsPrint";
function FooterCM(porps) {
  const { found, premiApp } = porps;

  const clas = useInvAF();
  const sty = {
    cntr: { textAlign: "center", paddingTop: 10 },
    lft: { textAlign: "left", padingLeft: 5 },
    rit: { textAlign: "right", padingRight: 5 },
    dirR: {
      direction: "rtl",
      color: "black",

    },
    dirL: { direction: "ltr" },
  };
  return (
    <Grid item container style={sty.dirR}>
      <Grid item container style={sty.cntr} spacing={0}>


      </Grid>
      <Grid
        item
        container
        xs={12}
        spacing={1}
        style={{ fontWeight: "bold", textAlign: "center" }}
      >
        <Grid item xs={12} style={{ fontFamily: "Amiri-Regular" }}>
          <Grid item xs={12} container className={clas.footerA}>
            <Grid item container xs={12} style={styleFooterNotesAr} >
              {found.BillNotes}
            </Grid>
          </Grid>
          {premiApp.billTemplate === 21 || premiApp.billTemplate === 24 &&
            (
              <>
                <br />
                <Grid item xs={12} container className={clas.footerB}>

                  <Grid item xs={4} style={{ fontFamily: "Amiri-Regular" }}>
                    {"الموظف"}{"  :"} {sto.usernames}
                  </Grid>
                  <Grid item xs={4} style={{ fontFamily: "Amiri-Regular" }}>
                    {" "}
                    {"  البائع" + "     " + " Salesmans Sign "}
                  </Grid>
                  <Grid item xs={4} style={{ fontFamily: "Amiri-Regular" }}>
                    {"توقيع المستلم" + "     " + " Receivrs Sign "}
                  </Grid>
                </Grid>
              </>
            )}

        </Grid>

      </Grid>
    </Grid>
  );
}
export default FooterCM;

